var CurrentUser = require("lib/account/CurrentUser");

class EvaluationItem extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	onClick() {
		this.props.handleChange(this.props.score);
	}

	render() {
		var classString = "btn btn-link " + "score" + this.props.score;
		if (!this.props.isSelected) {
			classString += " not-selected"
		}
		if (this.props.autoGraded) {
			classString += " autoGraded";
		}

		if (this.props.clickable == undefined) {
			var clickable = CurrentUser.isAdmin();
		} else {
			var clickable = this.props.clickable;
		}

		// This type of evaluation is barely (if at all) visible, and I'm removing preferences
		var ribbonType = "numbers"; // CurrentUser.getAdminPreferences().scoring_system;
		var ribbonPath = dynamicRequire("ribbons/" + ribbonType +
			"/" + this.props.score + ".png");

		if (clickable) {
			return (
				<img alt={ this.props.score } className={ classString }
					src={ ribbonPath } onClick={ this.onClick }></img>
			)
		} else {
			return (
				<img alt={ this.props.score } className={ classString }
					src={ ribbonPath } style={{ cursor: 'default' }}></img>
			)
		}
	}
};

EvaluationItem.propTypes = StrictPropTypes({
});

module.exports = EvaluationItem;



// WEBPACK FOOTER //
// ./modules/components/writing/evaluations/EvaluationItem.js